module.exports = __webpack_public_path__ + "img/3_x3.bcb57cd3.png";